import type { Transaction } from "prosemirror-state";

const ungroupGallery = (tr: Transaction, pos: number) => {
	const gallery = tr.doc.nodeAt(pos);
	return tr.replaceWith(pos, pos + gallery.nodeSize, gallery.content);
};

export default ungroupGallery;
